module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/1_1d270827ae02608cd51267e4b5626d01.png";